var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#17161B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.44 5-7.12-2.94a.88.88 0 0 0-.64 0L4.56 5a.92.92 0 0 0-.56.84v4.85a16.26 16.26 0 0 0 2.13 6.57 16.269 16.269 0 0 0 5.35 4.61.91.91 0 0 0 .52.13 1 1 0 0 0 .54-.17c1.5-1 3.9-2.31 5.37-4.57A15.47 15.47 0 0 0 20 10.69V5.84a.92.92 0 0 0-.56-.84Zm-6.89 15-.6.38a16 16 0 0 1-4-3.23c.265-.363.567-.698.9-1A6.85 6.85 0 0 0 12 17a6.39 6.39 0 0 0 3.1-.83h.05c.374.29.71.627 1 1a15.326 15.326 0 0 1-3.6 2.83Zm6-9.52a14.86 14.86 0 0 1-1.65 5.42c-.78-.82-1.32-1.34-1.89-1.3-.218.024-.427.1-.61.22a5.09 5.09 0 0 1-2.4.68 5.52 5.52 0 0 1-2.51-.64 2.125 2.125 0 0 0-.51-.2c-.58-.08-1.16.5-1.91 1.29a16.36 16.36 0 0 1-1.66-5.45V6.13L12 3.55l6.59 2.57-.04 4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-6.59a2.59 2.59 0 1 0 0 5.18 2.59 2.59 0 0 0 0-5.18Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h20v20H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.eb048f358425246fe1eb15029731a2cd.svg";
export { ForwardRef as ReactComponent };